module.exports = __webpack_public_path__ + "static/05-zorast@2x-b1ddb4900c88c1f1785e39897b01df26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/about-us/05-zorast@2x.jpg
// module id = 2516
// module chunks = 168707334958949